import { enumValues, MediaType } from '@repo-level/core-front';
import { useMedia } from 'modules/common/hooks/useMedia';
import type React from 'react';
import type { FC } from 'react';
import { useMemo } from 'react';

export interface ResponsiveProps {
  mobileS?: React.ReactNode | MediaType;
  mobile?: React.ReactNode | MediaType;
  tablet?: React.ReactNode | MediaType;
  desktop?: React.ReactNode | MediaType;
  desktopL?: React.ReactNode | MediaType;
}

export function isMediaType(x: any): x is MediaType {
  return typeof x === 'number' && enumValues(MediaType).includes(x);
}

export const Responsive: FC<ResponsiveProps> = ({
  mobileS,
  mobile,
  tablet,
  desktop,
  desktopL,
}) => {
  const { isDesktopL, isDesktop, isTablet, isMobile, isMobileS } = useMedia();

  const Component = useMemo(() => {
    const componentMap = {
      [MediaType.DESKTOP_L]: desktopL,
      [MediaType.DESKTOP]: desktop,
      [MediaType.TABLET]: tablet,
      [MediaType.MOBILE_S]: mobileS,
      [MediaType.MOBILE]: mobile,
    };

    const mediaChecks = [
      { check: isDesktopL, component: desktopL },
      { check: isDesktop, component: desktop },
      { check: isTablet, component: tablet },
      { check: isMobileS, component: mobileS },
      { check: isMobile, component: mobile },
    ];

    let component = mediaChecks.find(({ check }) => check)?.component;

    // you can pass for example tablet={MediaType.MOBILE}
    // and for tablet media mobile component will be used
    if (isMediaType(component)) {
      component = componentMap[component];
    }

    return component ?? null;
  }, [
    isDesktopL,
    desktopL,
    isDesktop,
    desktop,
    isTablet,
    tablet,
    isMobileS,
    mobileS,
    isMobile,
    mobile,
  ]);

  return <>{Component}</>;
};
